<template>
  <div>
    <page-title>Read Guide</page-title>
  </div>
</template>

<script>

export default {
  name: "nimasa-agent-guide",
  components: {},

  computed: {
  },

  data() {
    return {
    };
  }
};
</script>


